import PropTypes from "prop-types";
import jobType from "./jobType";

export default PropTypes.shape({
  applicationsCount: PropTypes.number,
  userApplicationCountRead: PropTypes.number,
  userApplicationCountUnread: PropTypes.number,
  candidatesLink: PropTypes.string,
  disengaged: PropTypes.bool,
  employerProfileLink: PropTypes.string,
  id: PropTypes.string,
  jobId: PropTypes.number,
  jobProfileLink: PropTypes.string,
  status: PropTypes.string,
  job: jobType,
  numberOfPlacements: PropTypes.number,
});
